module.exports = __webpack_public_path__ + "static/media/leak-pod.a17bb1db.svg";